import { useEffectOnce } from 'react-use';

import { useLazyGetApiAccountMeQuery } from 'shared/api/gsp';
import { useAppDispatch } from 'shared/hooks/store';
import { useStudentId } from 'shared/hooks/user';
import { studentActions } from 'shared/store/student';

export const useFetchUser = () => {
  const [getAccountMe, { data: user, isLoading }] =
    useLazyGetApiAccountMeQuery();
  const dispatch = useAppDispatch();
  const studentId = useStudentId();

  useEffectOnce(() => {
    getAccountMe().then(({ data: user }) => {
      const [defaultStudent] = user?.students ?? [];
      const student =
        user?.students?.find(({ id }) => id === studentId) ?? defaultStudent;

      dispatch(studentActions.setStudent(student));
    });
  });

  return { user, isLoading };
};
